/** 流水统计默认勾选的类型（与产品约定一致） */
export const DEFAULT_VISIBLE_BILL_TYPES = [
  'PLATFORM_WALLET_CREDIT',
  'CHAIN_DEPOSIT_MIRROR_TO_TOTAL',
  'CHAIN_WITHDRAW_MIRROR_FROM_TOTAL',
  'CHAIN_WITHDRAW_FEE_RECEIPT',
  'INTERNAL_TRANSFER_FEE_RECEIPT',
  'SPOT_TRADE_FEE_RECEIPT',
  'CONTRACT_OPEN_FEE_RECEIPT',
  'CONTRACT_CLOSE_FEE_RECEIPT',
  'CONTRACT_LIQUIDATION_FEE_RECEIPT',
  'SPOT_ROBOT_TRADE_MIRROR',
  'CONTRACT_ROBOT_USER_PROFIT_MIRROR',
  'CONTRACT_ROBOT_USER_LOSS_MIRROR',
  'CONTRACT_LIQUIDATION_RISK_RECEIPT',
  'COPY_TRADE_FOLLOWER_PROFIT_RECEIPT',
  'COPY_TRADE_FOLLOWER_PROFIT_REFUND',
  'COPY_TRADE_LEADER_PROFIT_PAYOUT',
  'CONTRACT_FUND_RATE_RECEIPT',
  'CONTRACT_FUND_RATE_PAYOUT',
  'ACTIVITY_REWARD_WITHDRAW_TO_CONTRACT',
  'PROFIT_BONUS_REWARD_PAYOUT',
  'PARTNER_REBATE_PAYOUT',
  'USER_SEND_COIN_PAYOUT',
];

/** 平台备付入金：可勾选展示，但净利润汇总始终排除（不参与加/减） */
export const PLATFORM_WALLET_CREDIT_BILL_TYPE = 'PLATFORM_WALLET_CREDIT';

/** 计算净利润时始终忽略的类型 */
export const NET_PROFIT_EXCLUDED_BILL_TYPES = [PLATFORM_WALLET_CREDIT_BILL_TYPE];

export const NET_PROFIT_BILL_TYPE = '__NET_PROFIT__';

export const VISIBLE_TYPES_STORAGE_KEY = 'tenant_public_account_bill_statistic_visible_types';

export function loadVisibleBillTypes(allTypes) {
  try {
    const raw = localStorage.getItem(VISIBLE_TYPES_STORAGE_KEY);
    if (!raw) {
      return normalizeSelection(DEFAULT_VISIBLE_BILL_TYPES, allTypes);
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) {
      return normalizeSelection(DEFAULT_VISIBLE_BILL_TYPES, allTypes);
    }
    return normalizeSelection(parsed, allTypes);
  } catch (e) {
    return normalizeSelection(DEFAULT_VISIBLE_BILL_TYPES, allTypes);
  }
}

export function saveVisibleBillTypes(types) {
  localStorage.setItem(VISIBLE_TYPES_STORAGE_KEY, JSON.stringify(types));
}

/** 恢复为产品默认勾选（不读 localStorage） */
export function defaultVisibleBillTypes(allTypes) {
  const allSet = new Set((allTypes || []).map((t) => t.billType));
  const picked = DEFAULT_VISIBLE_BILL_TYPES.filter((t) => allSet.has(t));
  return picked.length ? picked : Array.from(allSet);
}

/** 只保留当前接口仍存在的类型；若交集为空则回退默认 */
function normalizeSelection(selected, allTypes) {
  const allSet = new Set((allTypes || []).map((t) => t.billType));
  const filtered = selected.filter((t) => allSet.has(t));
  if (filtered.length) {
    return filtered;
  }
  return DEFAULT_VISIBLE_BILL_TYPES.filter((t) => allSet.has(t));
}
